import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import WarehouseContainer from 'app/containers/InventoryManagement/Warehouse'

const WarehouseContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <WarehouseContainer />
    </>
  )
}
const WarehouseContainerPage = memo(WarehouseContainerPageCpn, isEqual)

export default WarehouseContainerPage
